import React, { useState } from "react";
import { Spinner, Table, Dropdown, DropdownButton } from "react-bootstrap";
import DeleteButton from "../../assets/images/ThemeTable/delete-button.svg";
import { t } from "i18next";
import Utils from "../../utils";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import CustomPagination from "../common/CustomPagination";

function ThemeTable({
  page = 1,
  totalUserAssistants,
  totalRows = 20,
  pagination = true,
  pageLimit = 10,
  onPageChange,
  columns = [],
  data = [],
  actions = [],
  loader = false,
  emptyMessage = "No Data Found",
  onClickDelete,
  title = null,
  setPrompt,
  search = true,
  assistantOwnerId,
  isDropdownOpen,
  handleToggle,
  setIsDropdownOpen,
  setSortBy,
  sortOrder,
  setSortOrder,
  handleSortSelect,
  statusUpdate,
  stateValue,
}) {
  const userDetails = JSON.parse(Utils.getLocalStorageItem("currentUser"));

  const Link = ({ id, children, title }) => (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={id}>{title}</Tooltip>}
    >
      <span
        className="nav-item-tool"
        style={{
          float: "right",
        }}
      >
        {children}
      </span>
    </OverlayTrigger>
  );
  // const getShortName = item => {
  //   return (((item?.firstName) ? item.firstName[0] : '') + ((item?.lastName) ? item.lastName[0] : ''))?.toUpperCase()
  // };
  let mainUI = () => {
    return (
      <div className="overflow-auto table-theme">
        <Table size="md" striped>
          <thead>
            <tr>
              {columns.map((column, columnIndex) => {
                return (
                  <th scope="col">
                    {column?.divReq ? (
                      <div className="name-box d-flex">
                        {column?.checkbox && (
                          <div className="form-check">
                            {/* <input
                              type="checkbox"
                              id={`column-checkbox-${columnIndex}`}
                              className="form-check-input mt-0 custom-check-input"
                              checked={selectedCheckboxes.length === data.length}
                              onChange={handleSelectAllCheckboxChange}
                            /> */}
                          </div>
                        )}
                        <div className="d-flex align-itmes-start name-info-table">
                          <div className="img-usr-details">
                            <p>{column?.title}</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>{column?.title}</>
                    )}
                  </th>
                );
              })}
              {/* <th scope="col">
            <div className="name-box d-flex">
              <div className="form-check">
                <input
                  type="checkbox"
                  id={{}}
                  className="form-check-input mt-0 custom-check-input"
                />
              </div>
              <div className="d-flex align-itmes-start name-info-table">
                <div className="img-usr-details">
                  <p>File Name</p>
                </div>
              </div>
            </div>
          </th>
          <th scope="col">detected_type</th>
          <th scope="col">file_url</th>
          <th scope="col">metadata</th>
          <th scope="col">text</th>
          <th scope="col"></th> */}
            </tr>
          </thead>
          <tbody>
            {loader ? (
              <tr>
                <td colSpan={5}>
                  <div className="w-100 p-5 d-flex align-itmes-center justify-content-center">
                    <div className="d-flex flex-column align-items-center">
                      <Spinner size={20} variant="primary" />
                      <h5 className="mt-1">{t("loading")}</h5>
                    </div>
                  </div>
                </td>
              </tr>
            ) : data.length <= 0 ? (
              <tr>
                <td
                  colSpan={
                    actions.length > 0 ? columns.length + 1 : columns.length
                  }
                >
                  {/* <NotFoundApps size={200} message={emptyMessage} /> */}
                </td>
              </tr>
            ) : (
              <>
                {data.length &&
                  data.map((row, rowIndex) => {
                    return (
                      <tr>
                        {columns.map((column, columnIndex) => {
                          let value =
                            column?.title == "detected_type"
                              ? row?.[column?.field?.[0]]?.split(".")?.[1]
                              : row?.[column?.field?.[0]] ||
                                row?.[column?.field?.[1]];
                          let docType = "";
                          if (
                            value &&
                            typeof value == "string" &&
                            column?.title != "detected_type"
                          ) {
                            docType =
                              value?.split(".")?.[
                                value?.split(".")?.length - 1
                              ];
                          }
                          return (
                            <td>
                              {column?.checkbox ? (
                                <div className="name-box d-flex">
                                  <div className="form-check">
                                    {/* <input
                                      type="checkbox"
                                      id={`row-checkbox-${rowIndex}-${columnIndex}`}
                                      className="form-check-input custom-check-input mt-0"
                                      checked={selectedCheckboxes.includes(rowIndex)}
                                      onChange={(e) => handleCheckboxChange(e, rowIndex)}
                                    /> */}
                                  </div>
                                  <div className="d-flex align-itmes-start name-info-table">
                                    <div
                                      className={
                                        column?.iconUrlField
                                          ? "icon-files"
                                          : "img-user-table"
                                      }
                                    >
                                      {row?.[column?.imgUrlField] ||
                                      column?.iconUrlField ? (
                                        <img
                                          src={
                                            row?.[column?.imgUrlField] ||
                                            `/images/${docType}.svg`
                                          }
                                          alt=""
                                          width={40}
                                          height={40}
                                        />
                                      ) : (
                                        <div className="avtar-learningpath avatar-img">
                                          {value?.[0] + value?.[1] && (
                                            <span className="facilitator-name">
                                              {(
                                                value?.[0] + value?.[1]
                                              )?.toUpperCase()}
                                            </span>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    <div className="img-usr-details">
                                      {column?.document ? (
                                        <>
                                          <Link title={value} id="t-1">
                                            <p className="file-title mb-0 name-span">{`${value}`}</p>
                                          </Link>
                                          {/* <p className="sixe mb-0">
                                            {Utils?.formatBytes(row?.fileSize)}
                                          </p> */}
                                        </>
                                      ) : (
                                        <>
                                          <h5>{`${value}`}</h5>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ) : column?.fieldIcon == "DeleteButton" ? (
                                ((row.assignedby !== row?.emailid &&
                                  row.assignedby === userDetails?.emailID) ||
                                  (row.ownerId !== userDetails?.emailID &&
                                    userDetails.emailID ===
                                      assistantOwnerId)) &&
                                row.assignedby === userDetails?.emailID ? (
                                  <div className="button-wrap-tab">
                                    <span
                                      className="btn-table"
                                      style={
                                        column?.disabled
                                          ? { pointerEvents: "none" }
                                          : {}
                                      }
                                      onClick={() => column?.onClick(row)}
                                    >
                                      <img
                                        src={
                                          column?.fieldIcon == "DeleteButton"
                                            ? DeleteButton
                                            : ""
                                        }
                                        alt=""
                                      />
                                    </span>
                                  </div>
                                ) : (
                                  stateValue &&
                                  stateValue === row.assignedby &&
                                  row.ownerId !== stateValue && (
                                    <div className="button-wrap-tab">
                                      <span
                                        className="btn-table"
                                        style={
                                          column?.disabled
                                            ? { pointerEvents: "none" }
                                            : {}
                                        }
                                        onClick={() => column?.onClick(row)}
                                      >
                                        <img
                                          src={
                                            column?.fieldIcon == "DeleteButton"
                                              ? DeleteButton
                                              : ""
                                          }
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  )
                                )
                              ) : column?.fieldIcon == "DropDown" ? (
                                <Dropdown className="customdropdown-btn">
                                  <Dropdown.Toggle
                                    variant="success"
                                    id="dropdown-basic"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                    >
                                      <path
                                        d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99999C10.8334 9.53976 10.4603 9.16666 10.0001 9.16666C9.53984 9.16666 9.16675 9.53976 9.16675 9.99999C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z"
                                        stroke="#98A2B3"
                                        strokeWidth="1.66667"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M10.0001 4.99999C10.4603 4.99999 10.8334 4.6269 10.8334 4.16666C10.8334 3.70642 10.4603 3.33333 10.0001 3.33333C9.53984 3.33333 9.16675 3.70642 9.16675 4.16666C9.16675 4.6269 9.53984 4.99999 10.0001 4.99999Z"
                                        stroke="#98A2B3"
                                        strokeWidth="1.66667"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M10.0001 16.6667C10.4603 16.6667 10.8334 16.2936 10.8334 15.8333C10.8334 15.3731 10.4603 15 10.0001 15C9.53984 15 9.16675 15.3731 9.16675 15.8333C9.16675 16.2936 9.53984 16.6667 10.0001 16.6667Z"
                                        stroke="#98A2B3"
                                        strokeWidth="1.66667"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu style={{ cursor: "pointer" }}>
                                    {column?.dropDownList.map((data) => {
                                      return (
                                        <div
                                          className="list-drop"
                                          style={{ color: "red" }}
                                          onClick={() => data?.onClick(row)}
                                        >
                                          {data?.fieldIcon == "Delete" && (
                                            <>
                                              <img
                                                src={data?.imagePath || ""}
                                                alt={data?.imgAlt || ""}
                                              />
                                              {data?.title}
                                            </>
                                          )}
                                        </div>
                                      );
                                    })}
                                    {/* {type=='Home'&&<div className="list-drop">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_394_18059)">
                              <path
                                d="M5.33325 10.6666V12.5333C5.33325 13.28 5.33325 13.6534 5.47858 13.9386C5.60641 14.1895 5.81038 14.3935 6.06126 14.5213C6.34648 14.6666 6.71985 14.6666 7.46659 14.6666H12.5333C13.28 14.6666 13.6534 14.6666 13.9386 14.5213C14.1895 14.3935 14.3934 14.1895 14.5213 13.9386C14.6666 13.6534 14.6666 13.28 14.6666 12.5333V7.46665C14.6666 6.71991 14.6666 6.34654 14.5213 6.06133C14.3934 5.81044 14.1895 5.60647 13.9386 5.47864C13.6534 5.33331 13.28 5.33331 12.5333 5.33331H10.6666M3.46659 10.6666H8.53325C9.27999 10.6666 9.65336 10.6666 9.93857 10.5213C10.1895 10.3935 10.3934 10.1895 10.5213 9.93863C10.6666 9.65342 10.6666 9.28005 10.6666 8.53331V3.46665C10.6666 2.71991 10.6666 2.34654 10.5213 2.06133C10.3934 1.81044 10.1895 1.60647 9.93857 1.47864C9.65336 1.33331 9.27999 1.33331 8.53325 1.33331H3.46659C2.71985 1.33331 2.34648 1.33331 2.06126 1.47864C1.81038 1.60647 1.60641 1.81044 1.47858 2.06133C1.33325 2.34654 1.33325 2.71991 1.33325 3.46665V8.53331C1.33325 9.28005 1.33325 9.65342 1.47858 9.93863C1.60641 10.1895 1.81038 10.3935 2.06126 10.5213C2.34648 10.6666 2.71985 10.6666 3.46659 10.6666Z"
                                stroke="#344054"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_394_18059">
                                <rect width="16" height="16" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>{" "}
                          {t("duplicate")}
                        </div>}
                        {(type=='Home'||type=='Knowledgebase')&&<div className="list-drop" onClick={()=>handleDelete(assistant)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M10.6667 3.99998V3.46665C10.6667 2.71991 10.6667 2.34654 10.5213 2.06133C10.3935 1.81044 10.1895 1.60647 9.93865 1.47864C9.65344 1.33331 9.28007 1.33331 8.53333 1.33331H7.46667C6.71993 1.33331 6.34656 1.33331 6.06135 1.47864C5.81046 1.60647 5.60649 1.81044 5.47866 2.06133C5.33333 2.34654 5.33333 2.71991 5.33333 3.46665V3.99998M2 3.99998H14M12.6667 3.99998V11.4666C12.6667 12.5868 12.6667 13.1468 12.4487 13.5746C12.2569 13.951 11.951 14.2569 11.5746 14.4487C11.1468 14.6666 10.5868 14.6666 9.46667 14.6666H6.53333C5.41323 14.6666 4.85318 14.6666 4.42535 14.4487C4.04903 14.2569 3.74307 13.951 3.55132 13.5746C3.33333 13.1468 3.33333 12.5868 3.33333 11.4666V3.99998"
                              stroke="#F04438"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          {t("delete")}
                        </div>} */}
                                  </Dropdown.Menu>
                                </Dropdown>
                              ) : column?.formatSize ? (
                                Utils.formatBytes(value)
                              ) : (
                                value
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
              </>
            )}
          </tbody>
        </Table>
      </div>
    );
  };
  return (
    <>
      {title == null ? (
        mainUI()
      ) : (
        <div className="mid-content  assistant-user-list">
          <div className="wraper-tab d-flex flex-column">
            <div className=" table-header-sec d-flex align-items-center justify-content-between">
              <h4 className="d-flex align-items-center gap-2">
                {title}
                {/* <span className="pill">{totalPages} {t("users")}</span> */}
              </h4>
              <div className="btn-wrap-user gap-3 d-flex align-itemes-center">
                {/* <button className="table-btn me-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.99996 4.16675V15.8334M4.16663 10.0001H15.8333"
                    stroke="#0061AF"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Add Column
              </button>
              <button
                className="table-btn"
                // disabled={true}
              >
                Download all
              </button> */}
                {/* <div className="search-bar">
                  <div className="form-inline position-relative">
                    <input
                      className="input__field"
                      type="search"
                      placeholder={t("search")}
                      aria-label="Search"
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button className="secrico" type="submit"></button>
                  </div>
                </div> */}
                <div className="filter-drop">
                  <DropdownButton
                    align="end"
                    title="Sort By"
                    id="dropdown-menu-align-end"
                    className="custom-dropdown"
                    show={isDropdownOpen}
                    onToggle={handleToggle}
                  >
                    <div
                      className="sortoption"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="d-flex justify-content-end align-items-center">
                        {/* <div className="sorthead">Sort By</div> */}
                        <div className="close cursor-pointer">
                          <svg
                            onClick={() => setIsDropdownOpen(false)}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            fill="rgba(0,0,0,1)"
                          >
                            <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                          </svg>
                        </div>
                      </div>
                      <div className="sort-options">
                        <div className="d-flex gap-3 align-items-center">
                          <select
                            onChange={(event) => setSortBy(event.target.value)}
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="createdAt">Created On</option>
                            <option value="fileName">Name</option>
                            <option value="status">Status</option>
                            <option value="fileSize">Size</option>
                          </select>
                          <select
                            className={`form-select asbtn ${
                              sortOrder === "desc" ? "dsc" : "asc"
                            }`}
                            aria-label="Default select example"
                            onChange={(event) =>
                              setSortOrder(event.target.value)
                            }
                            value={sortOrder}
                          >
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                          </select>
                        </div>
                        <div className="btnsec mt-3 d-flex justify-content-end">
                          <button
                            className="default-btn"
                            onClick={handleSortSelect}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </DropdownButton>
                </div>

                <Dropdown className="customdropdown-btn">
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    <button className="builder-btn active">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M16.6693 8.74935V5.66602C16.6693 4.26588 16.6693 3.56582 16.3968 3.03104C16.1571 2.56063 15.7747 2.17818 15.3042 1.9385C14.7695 1.66602 14.0694 1.66602 12.6693 1.66602H7.33594C5.93581 1.66602 5.23574 1.66602 4.70096 1.9385C4.23056 2.17818 3.8481 2.56063 3.60842 3.03104C3.33594 3.56582 3.33594 4.26588 3.33594 5.66602V14.3327C3.33594 15.7328 3.33594 16.4329 3.60842 16.9677C3.8481 17.4381 4.23056 17.8205 4.70096 18.0602C5.23574 18.3327 5.93581 18.3327 7.33594 18.3327H10.0026M11.6693 9.16602H6.66927M8.33594 12.4993H6.66927M13.3359 5.83268H6.66927M15.0026 17.4993V12.4993M12.5026 14.9993H17.5026"
                          stroke="white"
                          strokeWidth="1.66667"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Add File
                    </button>
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={{ cursor: "pointer" }}>
                    <div className="list-drop" onClick={() => setPrompt()}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14 2H2M12 8.66667L8 4.66667M8 4.66667L4 8.66667M8 4.66667V14"
                          stroke="#344054"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Upload and add file
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            {mainUI()}{" "}
            <div className="d-flex justify-content-end btn-rfeshs">
              <button
                style={{
                  fontSize: "12px",
                  cursor: "pointer",
                  margin: "1rem",
                  width: "50px",
                }}
                className="rfresh-btn"
                onClick={() => statusUpdate()}
              >
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {pagination && totalUserAssistants > pageLimit && (
        <CustomPagination
          handlePageChange={onPageChange}
          between={4}
          totalLength={totalUserAssistants}
          totalPages={Math.ceil(totalUserAssistants / pageLimit)}
          limit={pageLimit}
        />

        // <div className="pagnation-table d-flex align-items-center justify-content-between">
        //   <button
        //     className="table-btn"
        //     onClick={() => onPageChange(page - 1)}
        //     // disabled={pagination && parseInt(page) == 1}
        //     style={
        //       pagination && parseInt(page) == 1
        //         ? { pointerEvents: "none", opacity: 0.5 }
        //         : {}
        //     }
        //   >
        //     <svg
        //       xmlns="http://www.w3.org/2000/svg"
        //       width="20"
        //       height="20"
        //       viewBox="0 0 20 20"
        //       fill="none"
        //     >
        //       <path
        //         d="M15.8332 9.99935H4.1665M4.1665 9.99935L9.99984 15.8327M4.1665 9.99935L9.99984 4.16602"
        //         stroke="#344054"
        //         strokeWidth="1.66667"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //       />
        //     </svg>{" "}
        //     {t("previous")}
        //   </button>
        //   <PaginationControl
        //     page={parseInt(page)}
        //     between={4}
        //     total={totalUserAssistants}
        //     limit={10}
        //     changePage={(page) => {
        //       if (onPageChange) onPageChange(page);
        //     }}
        //     next={false}
        //     last={false}
        //     ellipsis={1}
        //   />
        //   <button
        //     className="table-btn"
        //     onClick={() => onPageChange(parseInt(page) + 1)}
        //     // disabled={
        //     //   pagination && parseInt(totalRows) % parseInt(pageLimit) != 0
        //     //     ? parseInt(page) ==
        //     //       Math.trunc(parseInt(totalRows) / parseInt(pageLimit)) + 1
        //     //     : parseInt(page) ==
        //     //       Math.trunc(parseInt(totalRows) / parseInt(pageLimit))
        //     // }
        //     style={
        //       pagination && parseInt(page) == totalRows
        //         ? { pointerEvents: "none", opacity: 0.5 }
        //         : {}
        //     }
        //   >
        //     {t("next")}{" "}
        //     <svg
        //       xmlns="http://www.w3.org/2000/svg"
        //       width="20"
        //       height="20"
        //       viewBox="0 0 20 20"
        //       fill="none"
        //     >
        //       <path
        //         d="M4.16675 9.99935H15.8334M15.8334 9.99935L10.0001 4.16602M15.8334 9.99935L10.0001 15.8327"
        //         stroke="#344054"
        //         strokeWidth="1.66667"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //       />
        //     </svg>
        //   </button>
        // </div>
      )}
    </>
  );
}

export default ThemeTable;
